import * as React from "react";
import { forwardRef } from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";
import { Icon, Tooltip } from "components/common";
import useIsDirty from "views/hooks/useIsDirty";
import { Button } from "components/bootstrap";
const StyledIcon = styled(Icon)(
  ({ theme, $isDirty }) => css`
    color: ${$isDirty ? theme.colors.variant.dark.warning : "default"};
  `
);
const SaveViewButton = ({ title, onClick, disabled = false, disabledInfo = void 0 }, ref) => {
  const { t } = useTranslation("search");
  const isDirty = useIsDirty();
  const showDisabledInfo = disabled && !!disabledInfo;
  if (showDisabledInfo) {
    return /* @__PURE__ */ React.createElement(Tooltip, { label: disabledInfo, position: "bottom", withArrow: true }, /* @__PURE__ */ React.createElement(Button, { "aria-label": title, "aria-disabled": true, ref, disabled: true, allowClickWhenDisabled: true }, /* @__PURE__ */ React.createElement(StyledIcon, { name: "save", type: "regular", $isDirty: false }), " ", t("save_view.save")));
  }
  return /* @__PURE__ */ React.createElement(Button, { title, ref, onClick, disabled }, /* @__PURE__ */ React.createElement(StyledIcon, { name: "save", type: isDirty ? "solid" : "regular", $isDirty: !disabled && isDirty }), " ", t("save_view.save"));
};
export default forwardRef(SaveViewButton);
